export default __webpack_public_path__ + "static/media/NH21_722_ELLE_GLORIA2009.4ab86101.jpg";